import {DoctorDataModel} from '../../../models/doctors/doctor-data.model';
import {AppointmentDataModel} from './appoitment-model';
import {OperatoryDataModel} from '../../../models/clients/operatory-data.model';
import {CaseProcedureConfigurationModel} from '../../../models/caseProcedures/case-procedure-configuration.model';


export class AppointmentDialogDataV2Model {
    allDoctors: DoctorDataModel[] = [];
    appointment: AppointmentDataModel;

    procedures: CaseProcedureConfigurationModel[] = [];
    operatories: OperatoryDataModel[] = [];

    currentLocationId: string;
    timeIncrement: number;

    cancellingAppointment: boolean = false;
    confirmingAppointment: boolean = false;
    isReadOnly: boolean = false;

}
